import { camelize, getCurrentInstance, toHandlerKey } from "vue";
import { objectKeys } from "./utils/object";

export function forwardEmit<Name extends string>(emit: (name: Name, ...args: any[]) => void) {
  const vm = getCurrentInstance();

  const _events = vm?.type.emits as Name[] | { [key in Name]: any };
  const events = Array.isArray(_events) ? _events : objectKeys(_events);
  const result: Record<string, any> = {};

  if (!events?.length) {
    console.warn(`No emitted event found. Please check component: ${vm?.type.__name}`);
  }

  events?.forEach((ev) => {
    result[toHandlerKey(camelize(ev))] = (...arg: any) => emit(ev, ...arg);
  });

  return result;
}
